import React from 'react'


function StudentHome() {
  return (
    <div>

      HOme page for students
    </div>
  )
}

export default StudentHome
